//#region src/errors/ApiError.ts
var ApiError = class extends Error {
	body;
	status;
	response;
	hasToRetry = false;
	isUnknownError = false;
	shouldInvalidateForm = true;
	children = {};
	constructor(error, getApiErrorMessage = (e) => e.message ?? "Unknown error", getApiFallbackErrorMessage = (e) => e.detail ?? "") {
		const message = getApiErrorMessage(error);
		const fallBackMessage = getApiFallbackErrorMessage(error);
		super(message ?? fallBackMessage);
		this.body = error.body;
		this.status = error.status;
		this.response = error.response;
		this.isUnknownError = message === void 0;
		this.children = this.getChildren();
	}
	getChildren() {
		return {};
	}
};

//#endregion
export { ApiError };